import { render, staticRenderFns } from "./dept_import_dialog.vue?vue&type=template&id=f99bf894&"
import script from "./dept_import_dialog.vue?vue&type=script&lang=js&"
export * from "./dept_import_dialog.vue?vue&type=script&lang=js&"
import style0 from "./dept_import_dialog.vue?vue&type=style&index=0&id=f99bf894&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports